/**
 * The small coloured chips used across the support tables. They all share the `.tag` shape from
 * styles.css and only vary the colour, so a status reads the same wherever it appears.
 */

/** Invite / guest-link status (pending / accepted / expired). */
export function StatusTag({ status }: { status: string }) {
  const color =
    status === "accepted" ? "var(--lime)" :
    status === "expired" ? "var(--ink-faint)" :
    "var(--cyan)";
  return <span className="tag" style={{ fontSize: 10, color, borderColor: color }}>{status}</span>;
}

/** Organization role. Administrators are the ones worth spotting in a list, so only they are coloured. */
export function RoleTag({ role }: { role: string | null }) {
  if (!role) return <span className="faint">—</span>;
  const isAdmin = role === "Administrator";
  return (
    <span
      className="tag"
      style={{
        fontSize: 10,
        color: isAdmin ? "var(--cyan)" : "var(--ink-dim)",
        borderColor: isAdmin ? "var(--cyan-dim)" : "var(--line-strong)",
      }}
      title={isAdmin ? "Organization administrator — manages members, invitations and the licence" : "Organization member"}
    >
      {isAdmin ? "admin" : "member"}
    </span>
  );
}

/** Enabled/disabled state of an organization member. */
export function ActiveTag({ isActive }: { isActive: boolean }) {
  const color = isActive ? "var(--lime)" : "var(--red)";
  return (
    <span
      className="tag"
      style={{ fontSize: 10, color, borderColor: color }}
      title={isActive ? "Active — can sign in and uses a licence seat" : "Disabled — blocked from signing in"}
    >
      {isActive ? "active" : "disabled"}
    </span>
  );
}
